import { Icon } from '@chakra-ui/react'
import { GoPeople } from 'react-icons/go'

function Contributors() {
    return <Icon as={GoPeople} boxSize={5} color="gray" />
}

export default Contributors
